import React, { useEffect, useState } from "react";
import { fetchBookmarkList } from "../../../services/wishlist";
import { fetchBookmarks } from "../../../services/bookmark";
import { useNavigate } from "react-router-dom";
import SkellitonCard from "../../shared/skellitonCard/SkellitonCard";
import ConcertCard from "../../shared/concertCard/ConcertCard";
import BookmarkCard from "../../shared/concertCard/BookmarkCard";

const WhisList = () => {
  const accessToken = localStorage.getItem("@user");

  const [cards, setCards] = useState([]);
  const [userLogin, setUserLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(4);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    if (accessToken) {
      fetchBookmarks()
        .then((data) => {
          console.log("Bookmark List:", data[0].creator_profile_id);
          setCards(data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("API Error:", error);
          setLoading(false);
        });
    }
  }, [accessToken]);

  const handleNavigate = (name, id) => {
    const formattedName = name.replace(/\s+/g, "-"); // Replace spaces with dashes
    navigate(`/details?table=${encodeURIComponent(formattedName)}&id=${id}`);
  };

  return (
    <div>
      <section className="category-tab">
        <div
          data-current="Tab 1"
          data-easing="ease-in-out"
          data-duration-in="300"
          data-duration-out="300"
          className="tabs-2 w-tabs"
        >
          {cards.length <= 0 && !loading && (
            <>
              <div className="text-center text-xl h-56 text-gray-400 mt-16 flex flex-col items-center">
                <img
                  className="h-20 w-20 items-center"
                  src="https://cdn-icons-png.freepik.com/512/13543/13543330.png?ga=GA1.1.1598467923.1731688846"
                />
                Uh-oh! Your wishlist is feeling lonely. Add some sparkle to it!
              </div>
            </>
          )}
          <div className="w-layout-grid table-category-grid  ">
            {cards.map((card, index) => (
              <div
                key={index}
                onClick={() =>
                  handleNavigate(
                    card?.table_details?.title,
                    card.table_details.id
                  )
                }
              >
                <BookmarkCard
                  slide={card.table_details}
                  creator_profile_id={card.creator_profile_id}
                  wishlist={true}
                />
              </div>
            ))}
          </div>

          {loading ? (
            <>
              <div className="tab-content">
                <div className="w-layout-grid table-category-grid ">
                  {Array.from({ length: limit }, (_, index) => (
                    <SkellitonCard key={index} />
                  ))}
                </div>
              </div>
            </>
          ) : null}
        </div>
      </section>
    </div>
  );
};

export default WhisList;
